export * from "./SendbirdTranslationsConfig"
import { brandColors, neutralColors, buttonColors, getColors } from '../config/colorsConfig';

export default {
    brandColors,
    neutralColors,
    buttonColors,
    getColors,
};

